import React from "react";
import { redirectFromIframe } from "./utils";

function Footer(props) {
  return (
    <div className="flex items-center justify-center rounded-lg w-full text-sm py-6">
      <div className="flex justify-between w-full">
        <div className="flex flex-col pl-8 bk2:pl-2 bk2:text-xs">
          <div>
            <b>Business Hours (EST)</b>
          </div>
          <div>
            <b>Monday-Friday</b>: 9am - 5pm
          </div>
          <div>&nbsp;</div>
          <div className="italic w-[250px] bk2:w-[200px] text-sm">
            EZ ICE proudly has warehouses in both the US and Canada to quickly
            serve customers in both countries.
          </div>
        </div>
        <div className="flex flex-col pr-8 bk2:pr-2 bk2:text-xs">
          <div>
            <a
              className="text-gray-800 underline cursor-pointer"
              onClick={() =>
                redirectFromIframe(
                  "https://ezicerinks.com/pages/terms-of-service",
                )
              }
            >
              Terms of Service
            </a>
          </div>
          <div>
            <a
              className="text-gray-800 underline cursor-pointer"
              onClick={() =>
                redirectFromIframe("https://ezicerinks.com/pages/refund-policy")
              }
            >
              Refund Policy
            </a>
          </div>
          <div>
            <a
              className="text-gray-800 underline cursor-pointer"
              onClick={() =>
                redirectFromIframe(
                  "https://ezicerinks.com/pages/shipping-policy",
                )
              }
            >
              Shipping Policy
            </a>
          </div>
          <div>
            <a
              className="text-gray-800 underline cursor-pointer"
              onClick={() =>
                redirectFromIframe(
                  "https://ezicerinks.com/pages/privacy-policy",
                )
              }
            >
              Privacy Policy
            </a>
          </div>
          <div>
            <a
              className="text-gray-800 underline cursor-pointer"
              onClick={() =>
                redirectFromIframe("https://ezicerinks.com/pages/patents")
              }
            >
              Patent Information
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Footer;
